// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IConsultaPesquisaObservacao, Types } from './types';

export interface IRequestPesquisaObservacao {
	numeroRg: string;
	usuario: string;
	senha: string;
}

export function consultaPesquisaObservacaoRequest(
	token: string,
	data: IRequestPesquisaObservacao,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_OBSERVACAO_REQUEST,
		payload: data,
		token,
	};
}
export function consultaPesquisaObservacaoSuccess(
	payload: IConsultaPesquisaObservacao,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_OBSERVACAO_SUCCESS,
		payload,
	};
}
export function consultaPesquisaObservacaoFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_OBSERVACAO_FAILURE,
		payload: null,
	};
}

export function consultaPesquisaObservacaoClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_OBSERVACAO_CLEAR,
		payload: null,
	};
}
